import AxiosConfig from '@/config/axios-config'

export default {

  enviarCertificado (params) {
    return AxiosConfig.secureJalekoAPI().post(`/certificado/enviar`, params).then(response => response.data)
  }

}
